<template lang="html">
  <div class="centerx">
    <vs-popup
      @close="closePopup"
      class="holamundo"
      title="Sipariş Detayı"
      :active.sync="isPopupActive"
       v-if="invoiceData"
    >
      <p>

        <b-button pill variant="outline-secondary" @click="printInvoice" :class="{ 'hidden': isPrinting }">Yazdır     <b-icon icon="printer" style="color: #7952b3;"></b-icon>
        </b-button>
        <div class="panel-body">
          <h3></h3>
          <div>
            <p><strong></strong></p>
          </div>
        </div>
          <div class="invoice-header">
            <div class="row">
              <div class="col-xs-8">
                
              <div class="col-xs-4">
                <div class="media">
                  <div class="media-left">
                    <img class="media-object logo" src="" />                  
                  </div>
                    <ul class="media-body list-unstyled">
                      <li><strong>Sipariş No:{{ invoiceData.orderNumber }}</strong></li>
                      <li><strong>Tarih: {{ getNow() }}</strong></li>
                      <li>
                        <div class="square">
                        </div>
                      </li>
                    </ul>
                    <br>
                    <br>
                </div>
              </div>
            </div>
          </div>
          <h4 class="text-muted" style="font-weight: bold;">Sayın, {{ invoiceData.invoiceFullName }}</h4>
          <br>
          <ul class="list-unstyled">
            <li><strong>Müşteri Telefon | {{ invoiceData.telefon }} | </strong></li>
            <li><strong>Müşteri Mail | {{ invoiceData.customerEmail }} | </strong></li>
            <li><strong>Adres: | {{ invoiceData.shipFullAddress }} | </strong></li>
            <br>

          </ul>
          <div class="invoice-body">
            <div class="row">
              <div class="col-xs-5">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title"></h3>
                  </div>
                  <div class="panel-body">
                  </div>
                </div>
              </div>
              <div class="col-xs-7">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title"></h3>
                  </div>
                  <div class="panel-body">
                  </div>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title"></h3>
              </div>
              <table
              style="border-top: 1px solid grey; width: 100%"
              class="border-collapse"
            >
              <tr>
                <td>
                  <table style="width: 100% !important; text-align: center">
                    <tr>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        Stok Kodu
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        BARKOD
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN ADI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ÜRÜN FİYATI
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        ADET
                      </th>
                      <th
                        style="
                          text-align: center;
                          border-bottom: 1px solid grey;
                          padding: 3px;
                        "
                      >
                        TUTAR
                      </th>
                    </tr>

                    <tr :key="indextr" v-for="(tr, indextr) in rowDataDetail">
                      <td style="padding: 8px">
                        {{ tr.merchantSku }}<span v-if="tr.sku"> {{ tr.sku }}</span> 
                      </td>
                      <td style="padding: 8px">
                        {{ tr.barcode }}
                      </td>
                      <td style="padding: 8px">
                        {{ tr.productName }}
                      </td>
                      <td style="padding: 8px; text-align: right">
                        {{ (tr.price / tr.quantity).toFixed(2) }} TL
                      </td>
                      <td style="padding: 8px">{{ tr.quantity }} adet</td>
                      <td style="padding: 8px; text-align: right">
                        {{ tr.price.toFixed(2) }} TL
                      </td>
                    </tr>

                    <tr>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td style="padding: 8px"></td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          border-bottom: 1px solid grey;
                          border-left: 1px solid grey;
                          padding: 8px;
                        "
                      >
                        Toplam Tutar:
                      </td>
                      <td
                        style="
                          font-weight: bold;
                          border-top: 1px solid grey;
                          text-align: right;
                          border-bottom: 1px solid grey;
                          border-right: 1px solid grey;
                          padding: 8px;
                        "
                      >
                         {{ totalPrice.toFixed(2) }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <br />
            </table>
            </div>
           
            <div class="row">
              <div class="col-xs-7">
                <div a class="panel panel-default">
                  <div class="panel-body">
                    <i></i>
                    <hr style="margin:3px 0 5px" />
                  </div>
                </div>
              </div>
              <div class="col-xs-5">
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h3 class="panel-title"></h3>
                  </div>
                  <div class="panel-body">
                    <p></p>
                    <ul class="list-unstyled">
                      <li> <span class="mono"></span></li>
                      <li> <span class="mono"></span></li>
                      <li> <span class="mono"></span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-footer">
            <br/>
            <br/>
            <strong></strong>
          </div>
        </div>
      </p>
    </vs-popup>
  </div>
</template>

<script>
import Store from "../../../store/store";
import state from "../../../store/state";
import { fixTurkishCharsDeep } from "../../../helpers/fixTurkishChars";
export default {
    props: {invoiceData: {type:Object}, popupActivo:Boolean},
  data() {
    return {
        isPrinting: false,
        rowDataDetail: [],
        totalPrice:0.0
    };
  },
  methods: {
    getDetail(){
      var vm = this;
      vm.totalPrice = 0.0
      vm.veriler = [];
      const soap = require("soap");
      const url = Store.state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        program: this.invoiceData.program,
        orderNumber: this.invoiceData.orderNumber,
      };

      try {
        soap.createClient(url, function (err, client) {
          client.dbPazaryeriSiparisDetay(args, function (err, result) {
            if (result.dbPazaryeriSiparisDetayResult == "-1") {
              Store.dispatch("logout");
            }
            vm.veriler = fixTurkishCharsDeep(JSON.parse(result.dbPazaryeriSiparisDetayResult)); 
            console.log(vm.veriler)
            vm.rowDataDetail=vm.veriler
            vm.veriler.forEach((value, i) => {
            
            vm.totalPrice += value.price;
            //    console.log(value.price * value.quantity);
          });
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    getNow: function () {
      const today = new Date();
      const date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      return dateTime;
    },
    closePopup() {
      this.isPopupActive = false;
      this.$root.$emit('closePopupAction', false);
    },
    printInvoice() {
      this.isPrinting = true; // Yazdırma işlemi başladığında isPrinting true 
      setTimeout(() => {
        window.print();
        
        this.isPrinting = false; //tamamlandığında isPrinting false
    }, 100);
    }
  
  

  },
  watch: {
    invoiceData(val){
      this.data = val
return val
    },
    isPopupActive(newVal) {
      console.log(newVal);
      if (newVal === true) { 
        this.getDetail();
      } else if (newVal === false) { 
      }
    }
  },
  computed: {
    isPopupActive: {
      set() {
        return this.popupActivo;
      },
      get() {
        return this.popupActivo;
      }
    }
  }
};

</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
body{
    background:#fef6f6;
    
  }
  .con-vs-popup .vs-popup {
    -webkit-transition: all .2s;
    transition: all .2s;
    z-index: 100;
    width: 1000px;
    margin: 10px;
    max-width: calc(100% - 30px);
    max-height: calc(100% - 30px);
    border-radius: 6px;
    -webkit-box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
    box-shadow: 0 5px 20px 0 rgba(0,0,0,.1);
    background: #fff;
    -webkit-animation: rebound .3s;
    animation: rebound .3s;
}
*, *::before, *::after {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
  .logo{
    max-height:70px;
    border-radius:10px;
  }


.rag-amber {
  background-color: lightsalmon;
}
.rag-blue {
  background-color: lightblue;
}
.rag-green {
  background-color: rgb(12, 102, 12);
}
.con-vs-dialog {
  z-index: 52005555;
}
ul.media-body.list-unstyled {
  float: right; 
  background-color: #f0f0f0; 
  padding: 70px; 
  border: 1px solid hsl(273, 20%, 17%); 
  border-radius: 5px;
}
  ul.media-body.list-unstyled {
    float: right;
    background-color: #f0f0f0;
    padding: 10px;
    border: 1px solid #000;
    border-radius: 5px;
    
  }
  .media {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }
  
  .media-left {
    margin-top: 10px; 
  }

  
  ul.list-unstyled {
    list-style-type: none;
    padding: 0;
  }
  
  ul.list-unstyled li {
    margin-bottom: 10px; 
  }

h4.text-muted {
  margin-bottom: 0; /* Metin altındaki boşluğu kaldırır */
}


.hidden {
  display: none; /* Etkisiz hale geldiğinde butonu gizle */
}
  </style>